export const NDFL_FORM_ID = '3NDFL';
export const DEFAULT_REPORT_YEAR = 2016;
